var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"betaling-status"},[(_vm.isBetalingSuccess)?_c('app-betaling-succes',{attrs:{"status":_vm.status}}):_c('app-betaling-error',{attrs:{"status":_vm.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }